enum MandantActionTypesEnum {
    LOAD = "load_mandant",
    LOAD_SUCCESS = "load_mandant_success",
    LOAD_ERROR = "load_mandant_error",
    SET_THEME = "set_theme",
}

export default MandantActionTypesEnum;
